export interface ClientLogo {
    name: string;
    /**
     * Logo in public/images/clients/. Normalised to 120px tall webp with the
     * transparent padding trimmed off, so the bar can size them consistently.
     * The bar shows them in full colour on a white background, so the file has
     * to be artwork that works on light — see the note on the array below.
     */
    logo: string;
    /**
     * Draft entries only render on the dev server. The whole bar hides itself
     * when nothing is publishable yet, so production never shows empty slots.
     */
    draft?: boolean;
}

/**
 * Client names come from the portfolio (resources/js/data/projects.ts). The bar
 * caps both height and width, so the row stays optically balanced whatever the
 * aspect ratio; no particular order is required.
 *
 * ⚠️ The Sman Cars and Highmark files are DERIVED, not official artwork. Both were
 * supplied as white wordmarks for dark backgrounds (67% and 87% of their visible
 * pixels were near-white), which is invisible on this light bar. Their white parts
 * were recoloured to a neutral dark ink; the coloured marks are untouched. Replace
 * these two files if the client provides an official light-background version.
 */
export const clientLogos: ClientLogo[] = [
    { name: 'Food la Route', logo: '/images/clients/food-la-route.webp' },
    { name: 'Sman Cars', logo: '/images/clients/sman-cars.webp' }, // derived, see note
    { name: 'Suporta', logo: '/images/clients/suporta.webp' },
    { name: 'Broednest', logo: '/images/clients/broednest.webp' },
    { name: 'Highmark Software', logo: '/images/clients/highmark.webp' }, // derived, see note
    { name: 'Tribeo', logo: '/images/clients/tribeo.webp' },
];
